import {
    CUSTOMER_ACCOUNT_OVERLAY_KEY, STATE_CONFIRM_EMAIL,
    STATE_CREATE_ACCOUNT,
    STATE_FORGOT_PASSWORD,
    STATE_FORGOT_PASSWORD_SUCCESS, STATE_LOGGED_IN,
    STATE_SIGN_IN
} from '@scandipwa/scandipwa/src/component/MyAccountOverlay/MyAccountOverlay.config';
import { withRouter } from 'react-router-dom';

import Loader from 'Component/Loader';
import Popup from 'Component/Popup';
import {
    MyAccountOverlay as SourceMyAccountOverlay
} from 'SourceComponent/MyAccountOverlay/MyAccountOverlay.component';
import { noopFn } from 'Util/Common';

import './MyAccountOverlay.style';

/** @namespace Bodypwa/Component/MyAccountOverlay/Component */
export class MyAccountOverlayComponent extends SourceMyAccountOverlay {
    renderMap = {
        [STATE_SIGN_IN]: {
            render: () => this.renderSignIn(),
            title: __('Sign in')
        },
        [STATE_FORGOT_PASSWORD]: {
            render: () => this.renderForgotPassword(),
            title: __('Get password link')
        },
        [STATE_FORGOT_PASSWORD_SUCCESS]: {
            render: () => this.renderForgotPasswordSuccess()
        },
        [STATE_CREATE_ACCOUNT]: {
            render: () => this.renderCreateAccount(),
            title: __('Create new account')
        },
        [STATE_LOGGED_IN]: {
            render: noopFn
        },
        [STATE_CONFIRM_EMAIL]: {
            render: () => this.renderConfirmEmail(),
            title: __('Confirm the email')
        }
    };

    render() {
        const {
            isLoading,
            onVisible,
            isMobile
        } = this.props;

        return (
            <Popup
              id={ CUSTOMER_ACCOUNT_OVERLAY_KEY }
              mix={ { block: 'MyAccountOverlay' } }
              onVisible={ onVisible }
              isStatic={ isMobile }
              clickOutside={ false }
            >
                <Loader isLoading={ isLoading } />
                { this.renderMyAccount() }
            </Popup>
        );
    }
}

export const MyAccountOverlay = MyAccountOverlayComponent;

export default withRouter(
    MyAccountOverlay
);
